import { Locale, K } from "../constants";

const locale: Locale = {
  [K.CRONTAB]: "Crontab",
  [K.OR_MONTHLY]: "Or monthly ",
};

export default locale;
